<template>
  <!-- 休日出勤報告作成 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>休日出勤報告作成</h2>
      </CCardHeader>
      <CCardBody>
        <span class="preika-required-note"><span class="preika-required-note__mark" aria-hidden="true">*</span><span>が付いている項目は必須入力項目です</span></span>

        <ValidationObserver ref="obs">
          <CRow>
            <div class="container">
              <table class="table table-borderless preika-report-form">
                
                <!-- 日付 -->
                <tr>
                  <th scope="row">日付<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" class="preika-report-field preika-report-field--date">
                        <ValidationProvider name="日付" rules="required" v-slot="ProviderProps">
                          <CInput
                            class="preika-form-control preika-form-control--native-icon"
                            type="date"
                            :min="date_min()"
                            :max="date_max()"
                            v-model="date"
                          />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 開始・終了予定時間 -->
                <tr>
                  <th scope="row">予定時間<span class="asterisk">*</span></th>
                  <td>
                    <CRow class="preika-report-time-row">
                      <CCol sm="12" md="6" class="preika-report-field preika-report-field--time">
                        <ValidationProvider name="開始予定時間" rules="required" v-slot="ProviderProps">
                          <label>開始予定時間<span class="asterisk">*</span></label>
                          <CInput class="preika-form-control preika-form-control--native-icon" type="time" v-model="start_time" />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>

                      <CCol sm="12" md="6" class="preika-report-field preika-report-field--time">
                        <ValidationProvider name="終了予定時間" rules="required" v-slot="ProviderProps">
                          <label>終了予定時間<span class="asterisk">*</span></label>
                          <CInput class="preika-form-control preika-form-control--native-icon" type="time" v-model="end_time" />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 発生理由 -->
                <tr>
                  <th scope="row">発生理由<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" class="preika-report-field preika-report-field--wide">
                        <ValidationProvider name="発生理由" rules="required|max:100" v-slot="ProviderProps">
                          <CTextarea
                            class="preika-report-reason-input"
                            v-model="reason"
                            rows="4"
                          />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                </CCol>
                <CCol class="text-center">
                  <save-button
                    :label="'報告'"
                    :loading="loading"
                    @click="whenValid('obs', apply)"
                    class="btn btn-primary"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <label class="mt-2">※ 保存すると上長向けの報告一覧へ反映されます。自分の申請一覧での申請操作はありません。</label>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>


<script>
import submitWhenValidMixin from '@/mixins/submitWhenValidMixin'
import ConstList from "./../../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import axios from "axios";
import SaveButton from "./../../common/SaveButton";
import {
  buildSaveParams,
  isReportableFailure,
  saveErrorMessage,
} from "./holidayWorkSave";
export default {
  mixins: [submitWhenValidMixin],
  name: "RegisterInput",
  components: { SaveButton },
  data() {
    return {
      date: "",
      start_time: "",
      end_time: "",
      reason: "",
      holidayworksMasterList: "",
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.holidayworksMasterList = ConstList.ROUTE_HOLIDAYWORKS_MASTERLIST;
  },

  computed: {
    DATE_MIN() {
      return ConstList.DATE_MIN;
    },
    DATE_MAX() {
      return ConstList.DATE_MAX;
    },
  },

  methods: {
    // 登録内容を送信
    apply: function () {
      //二重サブミット対策
      if (this.submit_flg) return;
      //フラグがfalseならば、フラグをtrueにしたうえでsubmit
      this.submit_flg = true;

        //二重サブミット後の処理
        if (confirm) {
          this.loading = true;
          // 送る形は修正画面と同じ組み立てを使う。ここで ":00" を継ぎ足すと、
          // 未入力のとき ":00" になってBackendの必須チェックを通り抜ける。
          const params = buildSaveParams({
            date: this.date,
            startTime: this.start_time,
            endTime: this.end_time,
            reason: this.reason,
          });
          return axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/holidayWorkRegister",
              params
            )
            .then((response) => {
              this.submit_flg = false;
              if (response.data === ConstList.SUCCESS) {
                alert(ConstList.REGISTER_MESSAGE);
                this.$router.push({ name: "休日出勤報告" });
              } else {
                alert(ConstList.APPLY_ERROR);
              }
            })
            .catch((error) => {
              this.submit_flg = false;
              // 入力の不備はBackendが項目ごとの文言で返す。障害ではないので
              // frontErrorへは積まず、返ってきた文言をそのまま出す。
              if (!isReportableFailure(error)) {
                alert(saveErrorMessage(error, ConstList.APPLY_ERROR));
                return;
              }
              axios
              .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
              .then(() => {
                alert(requestFailureMessage(error));
              })
              .catch(() => {
                alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
    },
    date_min() {
      return ConstList.DATE_MIN;
    },
    date_max() {
      return ConstList.DATE_MAX;
    },
    valueCheck: function () {
      if ((this.date != '') || 
        (this.start_time != '') || 
        (this.end_time != '') || 
        (this.reason != '')) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_HOLIDAYWORKS_LIST,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_HOLIDAYWORKS_LIST,
        })
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}
</style>
